module.exports = __webpack_public_path__ + "img/icon_menu.a7f457a1.svg";